import React, { useCallback, useEffect, useState } from 'react';
import css from './ComponentList.module.scss';
import { NewVehicle, ascPageviewInput } from 'src/models';
import VehicleCard from '../VehicleCard/VehicleCard';
import { IPropertyList } from '../../DesktopPane/PropertyOptions/PropertyOptions';
import { ascPageview } from 'src/helpers/EventHelper/EventHelper';
import { ComponentMapIds } from 'src/components/map';
import ScrollBar from '../../../ScrollBar/ScrollBar';

interface IProps {
    list: IPropertyList[];
    makesBuilt: boolean;
    modelsBuilt: boolean;
    yearsBuilt: boolean;
    currentMainPane: string;
    click: (target: EventTarget | string, id?: string) => void;
    width?: string;
    height?: string;
    selectedOptions: NewVehicle;
    pane?: string;
    otherList?: string[];
    theme: string;
    defaultLen: number;
    Itype: string | undefined;
}

const ComponentList = (props: IProps) => {
    const [pageViewEvent, setPageViewEvent] = useState(false);
    const {click, selectedOptions, height, width, pane, list} = props;

    const onClick = useCallback((target: EventTarget | string, id?: string) => {
        click(target, id);
    }, [click]);
    const otherListLength = props.otherList?.length ? 1 : 0;
    const itemResultsLength = otherListLength + list.length;

    useEffect(() => {
        if (props.currentMainPane === ComponentMapIds.AddVehicle) {
            if (pane === 'Makes' && props.makesBuilt) {
                setPageViewEvent(true);
            }
            if (pane === 'Years' && props.yearsBuilt) {
                setPageViewEvent(true);
            }
            if (pane === 'Models' && props.modelsBuilt) {
                setPageViewEvent(true);
            }
        }
    }, [pane, props.currentMainPane, props.makesBuilt, props.modelsBuilt, props.yearsBuilt]);

    useEffect(() => {
        const newVehicle = {
            id: '',
            vin: selectedOptions.vin ?? '',
            makeCode: selectedOptions.makeCode ?? '',
            make: selectedOptions.make ?? '',
            model: selectedOptions.model ?? '',
            imagePath: '',
            year: selectedOptions.year ?? '',
            color: selectedOptions.year ?? '',
            style: selectedOptions.trim ?? '',
            prevMileage: 0,
            prevRoDate: '',
            nextAppt: '',
            lastAdv: '',
            lastAdvName: '',
            lastAdvImage: '',
            lastTrans: '',
            lastTransLit: '',
            nameId: '',
        };
        if (pageViewEvent) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'itemlist',
                errorCode: '',
                itemResults: itemResultsLength.toString(),
            };
            ascPageview(ascPageViewInp, [newVehicle]);
            setPageViewEvent(false);
        }
    }, [
        itemResultsLength,
        pageViewEvent,
        props.makesBuilt,
        props.yearsBuilt,
        props.modelsBuilt,
        props.currentMainPane,
        selectedOptions,
    ]);

    const elements = list.map((el) => (
        <VehicleCard
            key={el.id ? el.id : el.name}
            id={el.name}
            click={(target) => onClick(target, el.id)}
            options={selectedOptions}
            height={height}
            width={width}
            image={el.image}
            pane={pane}
            otherList={props.otherList !== undefined ? props.otherList : []}
            theme={props.theme}
            defaultLen={props.defaultLen}
            Itype={props?.Itype}
        />
    ),
    );

    const rows: JSX.Element[] = [];

    for (let index = 0; index < elements.length; index = index + 3) {
        rows.push((
            <div className={css.componentRow} key={index}>
                {elements.slice(index, index + 3)}
            </div>
        ));
    }

    const output = (
        <ScrollBar scrollHorizontal theme={props.theme}>
            <div className={css.componentOptions} id='componentList'>
                {rows}
            </div>
        </ScrollBar>
    );

    return output;
};

export default ComponentList;